export default {
    computed: {
        noteList() {
            return this.$store.state.noteList
        },
        nodeIdList: {
            get() {
                return this.$store.state.note.nodeIdList
            },
            set(val) {
                this.$store.commit('note/setNodeIdList', val)
            }
        },
        //分類後的筆記
        nodeGurup() {
            return this.$store.getters['nodeGurup']
        }
    },
    methods: {
        getMyNote() {
            this.$store.dispatch('getMyNote')
        },
        addVocabularyToNote(vocabularyId) {
            this.$store.dispatch('addVocabularyToNote', vocabularyId)
            this.$store.commit('note/addNoteId', vocabularyId)
        },
        removeVocabularyToNote(vocabularyId) {
            this.$store.dispatch('removeVocabularyFromNote', vocabularyId)
            this.$store.commit('note/removeNoteId', vocabularyId)
        },
        removeVocabularyToNoteAndReload(vocabularyId) {
            this.$store.dispatch('removeVocabularyFromNote', { vocabularyId })
            this.$store.commit('note/removeNoteId', vocabularyId)
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/myNoteDelegate.js